import React, { useState, useCallback } from 'react';
import Card from 'components/cards/Card01';
import Datepicker from 'components/actions/DatePicker';
import AnalyticsSerive from 'api/services/AnalyticsService';
import { useTranslation } from "react-i18next";
import { getDateRangeString, getI18nValue, getChannelLanguageString } from 'utils/Utils';
import { useAxios } from 'hooks/useAxios';
import LayoutWrapper from 'components/LayoutWrapper';
import { RiRefreshFill, RiChatDeleteFill, RiChatCheckFill } from 'react-icons/ri'
import { FaUserCheck } from 'react-icons/fa'
import { HiUsers, HiChatAlt2, HiChartBar } from 'react-icons/hi'
import { MdAccessTimeFilled, MdTimer } from 'react-icons/md'
import { SiGooglechat } from 'react-icons/si'
import ChannelSelect from './ChannelSelect';
import LanguageSelect from './LanguageSelect';
import { ExportCSV } from 'components/ExportCSV';

function Overview() {
    const { t } = useTranslation();

    const [selectedDateRanges, setSelectedDateRanges] = useState(
        {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            key: 'selection',
        }
    );

    const [channel, setChannel] = useState('');
    const [language, setLanguage] = useState('');

    // Stable reference so MemoDatepicker never re-renders (setDateRanges is already
    // stable from useState, but useCallback makes the intent explicit).
    const handleDateChange = useCallback((newRanges) => setSelectedDateRanges(newRanges), []);

    const [data, error, loading] = useAxios(AnalyticsSerive.getOverview(selectedDateRanges, channel, language))

    return (

        <div className='p-4 col-span-full sm:col-span-full xl:col-span-full bg-white shadow-sm rounded-sm border border-gray-200 min-h-[320px]'>
            <div className="sm:flex sm:justify-between sm:items-center border-b border-gray-100 mb-4">
                <div className='mb-4'>

                    <header className='text-xl font-semibold text-gray-800 '>{t(getI18nValue('analytics.overview', "title"))}</header>
                    <p className='text-sm font-light'>{t(getI18nValue('analytics.overview', "description"))}</p>            </div>
                <div className="flex items-center gap-2 flex-wrap mb-6 p-4 bg-white shadow-sm rounded-sm border border-gray-200">
                    <ExportCSV csvData={data} disabled={!data} fileName={`overview_${getDateRangeString(selectedDateRanges) + getChannelLanguageString(channel, language)}`} />
                    <ChannelSelect value={channel} onChange={setChannel} />
                    <LanguageSelect value={language} onChange={setLanguage} />
                    <Datepicker callBack={handleDateChange} />
                </div>
            </div>
            <LayoutWrapper error={error} loading={loading} variant="cards" isEmpty={!loading && !data}>
                <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-2 '  >

                    {!!data && Object.entries(data).map((item, i) => {
                        return (
                            <Card
                                title={t(getI18nValue(`analytics.overview.${item[0]}`, "title"))}
                                description={t(getI18nValue(`analytics.overview.${item[0]}`, "description"))}
                                value={item[1]}
                                icon={getIcon(item[0])}
                                key={"overview_" + item[0]}
                            />
                        )
                    })}
                </div>
            </LayoutWrapper>


        </div >


    );
}


export default Overview;


const getIcon = (key) => {
    let iconList = {
        'engaged_users': < FaUserCheck />,
        'retention_rate': <RiRefreshFill />,
        'avg_conversation_duration': <MdAccessTimeFilled />,
        'avg_response_time':         <MdTimer />,
        'total_conversations': < SiGooglechat />,
        'length': <HiChatAlt2 />,
        'handled_requests': <RiChatCheckFill />,
        'rejected_requests': <RiChatDeleteFill />,
        'total_users': <HiUsers />,
        'avg_messages_per_user': <HiChartBar />,
        'default': <div className='w-5 h-5' />
    };
    return (iconList[key] || iconList['default']);
}

